import { useEffect, useRef, useState } from "react";

const IDLE_MINUTES = 15;
const WARNING_MINUTES = 13;

export function useIdleTimeout(onLogout) {
  const [showWarning, setShowWarning] = useState(false);
  const idleTimer = useRef(null);
  const warningTimer = useRef(null);

  function resetTimers() {
    clearTimeout(idleTimer.current);
    clearTimeout(warningTimer.current);
    setShowWarning(false);

    warningTimer.current = setTimeout(() => {
      setShowWarning(true);
    }, WARNING_MINUTES * 60 * 1000);

    idleTimer.current = setTimeout(() => {
      onLogout();
    }, IDLE_MINUTES * 60 * 1000);
  }

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "click"];
    events.forEach(e => window.addEventListener(e, resetTimers));
    resetTimers();

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimers));
      clearTimeout(idleTimer.current);
      clearTimeout(warningTimer.current);
    };
  }, []);

  return { showWarning, resetTimers };
}
